import React from 'react';
import PropTypes from 'prop-types';

import FormManager from 'src/core/gd-form/common/form-manager';
import Form from "core/gd-form/form/form-ui5/form";
import FormRow from "src/core/gd-form/form/form-ui5/form-row";
import Input from "core/gd-form/form-element/input/input";
import FormError from "src/core/gd-form/common/form-error/form-error";
import SelectorInline from "../../gd-components/selector/inline/selector-inline";

export default class ModalMeetingNote extends React.Component {

    static propTypes = {
        note        : PropTypes.object,
        showAccess  : PropTypes.bool,

        onSubmit    : PropTypes.func
    }

    constructor(props) {
        super(props);

        const initFormData = {
            title:  this.props.note ? this.props.note.title : '',
            access: this.props.note ? this.props.note.access : gd.const.meeting.noteAccess.PRIVATE
        };

        const formStructure = {
            fields: {
                title:  { type: 'input',    isRequired: true},
                access: { type: 'select',   isRequired: false}
            },
            isFormChanged: true,

            onSubmit: this.onSubmit
        };

        this.form = new FormManager(formStructure, initFormData);
    }

    componentDidMount() {
        if (this.input) this.input.focus();
    }

    getForm = () => this.form;

    onAccessChanged = (value) => {
        this.form.onFormComponentValueChange('access', value);
        this.forceUpdate();
    }

    onSubmit = (result) => {
        if (this.props.onSubmit) this.props.onSubmit(result);
    }

    render() {
        const accessOptions = [
            {id: gd.const.meeting.noteAccess.PRIVATE,  label: "Private",  icon: 'i5-lock'},
            {id: gd.const.meeting.noteAccess.PUBLIC,   label: "Public",   icon: 'i5-users'}
        ];

        return (
            <div className="ui5-plate modal-form">
            <Form form={this.form} size="size-30-70">
                <div className="f-tbl">
                    <FormRow label="Title">
                        <Input ref={r=>this.input = r} size="big" form={this.form} name="title"/>
                        <FormError form={this.form} name="title" />
                    </FormRow>

                    {this.props.showAccess &&
                        <FormRow label="Access">
                            <SelectorInline items={accessOptions} selectedId={this.form.getValue('access')} onChange={this.onAccessChanged} />
                        </FormRow>}
                </div>
            </Form>
            </div>
        );
    }
}